import PropTypes from "prop-types";

export const IEvent = {
  category: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
};

export const attachGaDataAttributes = (event) => ({
  "data-on": "click",
  "data-event-category": event.category,
  "data-event-action": event.action,
  "data-event-label": event.label,
});
